<template lang="html">
  <layout-private>
    <div class="">
      <h2>Excluded Payments</h2>
      <hr />
      <div v-if="!hasOdConnection || !isPracticeUser">
        <p class="lead">You don't have the required permissions to use this page.</p>
      </div>
      <div class="row" v-if="hasOdConnection && isPracticeUser">
        <p v-if="!showInstructions" class="col-12"><button @click="showInstructions=true" class="btn btn-sm btn-app"><i class="far fa-fw fa-plus"></i> show instructions</button></p>
        <div v-if="showInstructions"class="col-12 col-xl-10">
          <p class="lead">This list includes Health Assurance subscription payments that failed to post into Open Dental:</p>
          <ul>
            <li>Successful payments for members with no PatNum entered</li>
            <li>Successful payments with an amount that doesn't match a Health Assurance subscription plan price (prorated payments from plan changes, family plans)</li>
            <li>Failed payments due to declined credit cards</li>
            <li>Any payments that failed posting into Open Dental despite having a PatNum and matching amount, after the HA Procedure Code posted successfully</li>
          </ul>
          <p class="instructions"><em><strong>Tip:</strong></em> You can mark an item as complete, and then it will move to the 2nd list of completed items at the bottom of the page.</p>
          <p><button @click="showInstructions=false" class="btn btn-sm btn-app"><i class="far fa-fw fa-times"></i> close instructions</button></p>
        </div> <!-- /.col-x -->

        <div class="col-12">
          <h3>Incomplete Items</h3>
          <excluded-list :itemList="incompleteItems" v-on:update-item="handleUpdateItem"></excluded-list>

          <h3>Complete Items</h3>
          <excluded-list :itemList="completeItems" :isCompleteTable="true" v-on:update-item="handleUpdateItem"></excluded-list>
        </div> <!-- /.col-x -->

      </div> <!-- /.row -->

    </div>
  </layout-private>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import LayoutPrivate from '../components/LayoutPrivate.vue'
import ListErrors from '../components/ListErrors.vue'
import ExcludedList from '../components/ExcludedList.vue'

export default {
  props: [''],
  components: {
    LayoutPrivate, ListErrors, ExcludedList
  },
  data () {
    return {
      errors: [],
      excludedItems: {}, // objects of objects are only reactive if set with this.$set(this.excludedItems, id, value)
      showInstructions: false,
    }
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'hasOdConnection', 'isPracticeUser']),
    incompleteItems() {
      const entries = Object.entries(this.excludedItems);
      const filtered = entries.filter(([key,val]) => !val.complete);
      // sort by timestamp
      // filtered.sort((a,b) => a[1].timestamp - b[1].timestamp);
      return Object.fromEntries(filtered);
    },
    completeItems() {
      const entries = Object.entries(this.excludedItems);
      const filtered = entries.filter(([key,val]) => val.complete);
      // sort by timestamp
      // filtered.sort((a,b) => a[1].timestamp - b[1].timestamp);
      return Object.fromEntries(filtered);
    },
  },
  
  watch: {
    user_props() {
      if(this.user_props) {
        this.loadExcludedItems();
      }
    },
  },
  methods: {
    handleUpdateItem(id, item) {
      console.log('handleUpdateItem',id);
      console.log('handleUpdateItem',item);
      // this.excludedItems[id].complete = newCompletionStatus;
      this.$set(this.excludedItems, id, item);
    },
    loadExcludedItems() {
      // console.log(this.user);
      // console.log(this.user_props);
      if(!this.user || !this.user_props || !this.user_props.owned_account_id) {
        console.log("can't loadExcludedItems, missing user data");
        return;
      }
      console.log("loadExcludedItems");
      const locDocPath = `owners/${this.user.uid}/accounts/${this.user_props.owned_account_id}/excluded_payments`;
      // console.log({locDocPath});
      // load from firestore
      Vue.firestore
        .collection(locDocPath)
        .orderBy('timestamp', 'desc')
        .get()
        .then(docSnapshots => {
          // console.log("items loaded",docSnapshots.docs.length);
          if(docSnapshots && docSnapshots.docs.length) {
            docSnapshots.docs.forEach(snap => {
              this.$set(this.excludedItems, snap.id, snap.data());
            })
            return true;
          }
          return false;
        })
        .catch(err => console.log(err));
    },
  },
  mounted () {
    this.loadExcludedItems();
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

h3 {
  margin: 50px 0 10px !important;
}
</style>